import { useCallback, useMemo } from 'react';
import dayjs from 'dayjs';
import useSessionPersistedState from '../../../hooks/useSessionPersistedState';
import { buildMisQueryParams } from '../utils/buildMisQueryParams';
import { DEFAULT_MIS_FILTERS } from '../utils/misConstants';

const getDefaultPeriod = () => ({
  startDate: dayjs().startOf('month').format('YYYY-MM-DD'),
  endDate: dayjs().format('YYYY-MM-DD'),
  periodPreset: 'this_month',
});

const useMisDashboardFilters = () => {
  const [filters, setFilters] = useSessionPersistedState('misDashboard:filters:v3', () => ({
    ...DEFAULT_MIS_FILTERS,
    ...getDefaultPeriod(),
  }));

  const setFilter = useCallback(
    (key, value) => {
      setFilters((prev) => ({
        ...prev,
        [key]: value,
      }));
    },
    [setFilters],
  );

  const patchFilters = useCallback(
    (patch) => {
      setFilters((prev) => ({
        ...prev,
        ...patch,
      }));
    },
    [setFilters],
  );

  const clearAll = useCallback(() => {
    setFilters({
      ...DEFAULT_MIS_FILTERS,
      ...getDefaultPeriod(),
    });
  }, [setFilters]);

  const queryParams = useMemo(() => buildMisQueryParams(filters), [filters]);

  return {
    filters,
    setFilter,
    patchFilters,
    clearAll,
    queryParams,
  };
};

export default useMisDashboardFilters;
